// @flow
import React from 'react'
import styled from 'styled-components'
import type {Node} from 'react'

type Props = {
    headline: string,
    children: Node
}


export default function Block (props:Props) {
    return (
        <Wrapper>
            <Headline>{props.headline}</Headline>
            <Content>{props.children}</Content>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    margin-bottom: 10px;
`

const Headline = styled.h2`
    border-bottom: 1px solid rgba(89,111,121, 0.5);
    color: rgb(89,111,121);
    padding-bottom: 10px;
`

const Content = styled.div``


// WEBPACK FOOTER //
// ./src/config/Block.js